import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import RepairshopModalPage from '../../../containers/masters/Repairshop/RepairshopModalPage'
import RepairshopUsersAddModalPage from '../../../containers/masters/Repairshop/RepairshopUsersAddModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class RepairshopMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        name: null,
        description: null
      },
      isUsers: false
    }
  }

  componentDidMount () {
    this.props.actions.fetchRepairshopList()
    this.props.actions.fetchOrganizedUnitsAll()
  }

  componentDidUpdate () {
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchRepairshopList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchRepairshopList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  search () {
    this.props.actions.fetchRepairshopList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  openModal (repairshop, type = 'openEditRepairshopModal') {
    if (repairshop == null) {
      this.props.actions.openRepairshopModal(repairshop)
      this.setState({ isUsers: false })
    } else if (type === 'openEditRepairshopModal') {
      this.props.actions.openEditRepairshopModal(repairshop)
      this.setState({ isUsers: false })
    } else {
      this.props.actions.openRepairshopUsersModal(repairshop.userRepairshop, repairshop.repairshopId)
      this.setState({ isUsers: true })
    }
  }

  handleorganizedUnitComboChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  handleNameChange (name) {
    if (this.state.filter.name !== name) {
      this.setState({ filter: { ...this.state.filter, name } })
    }
  }

  handleDescriptionChange (description) {
    if (this.state.filter.description !== description) {
      this.setState({ filter: { ...this.state.filter, description } })
    }
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        organizedUnitId: null,
        name: null,
        description: null
      }
    })
    this.props.actions.fetchRepairshopList({ pageSize: 10 })
  }

  render () {
    const {
      t, repairshopList, pagesCount, repairshopListCount, filter,
      combos: { organizedUnitsAllCombo },
      filter: { page },
      actions: { fetchRepairshopList, deleteRepairshop }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'repairshopMasterPage' })
    const tKey = 'MASTERS.REPAIR_SHOPS_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const userTooltip = (<Tooltip id="editTooltip">{t(`${tKey}USERS`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.organizedUnitId || this.state.filter.description || this.state.filter.name)
    return (
      <div id='repairshopMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => this.openModal(null, 'openEditRepairshopModal')}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitId"
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleorganizedUnitComboChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.search()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    // this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(repairshopList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                        {t(`${tKey}OU`)}
                        <i className={this.getSortIcon('organizedUnitId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {repairshopList && repairshopList.map((repairshop, idx) => {
                      return (
                        <tr key={idx} className={repairshop.isDeleted ? 'is-deleted' : ''}>
                          <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === repairshop?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === repairshop?.organizedUnitId).value}</td>
                          <td>{repairshop.name}</td>
                          <td>{repairshop.description}</td>
                          <td className='actions'>
                            {!repairshop.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => this.openModal(repairshop, 'openEditRepairshopModal')}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={userTooltip}>
                                  <a className='_Btn accent stk o-icn ' onClick={() => this.openModal(repairshop, 'openRepairshopUsersModal')}>
                                    <i className="iDocIcon-user-user-menu"></i>
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteRepairshop(repairshop.repairshopId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })}
                  </tbody>
                </Table>
              }
              {(repairshopList === null || repairshopList === undefined || repairshopList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={repairshopListCount}
                    onSelectAction={(value) => fetchRepairshopList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>

        {this.state.isUsers
          ? <RepairshopUsersAddModalPage/>
          : <RepairshopModalPage/>
        }
      </div>
    )
  }
}

export default reduxForm({
  form: 'listRepairshop'
})(RepairshopMaster)
